// - - - - - - - - - -
// attributeCellKey.js — #453
//
// attributeCellPayrollKey(payrollNo, formatPayroll) → string
//
// The ONE payroll key used to match an Attributes document to a grid cell.
//
// WHY THIS EXISTS (SUP-9743, secondary finding): the read side and the write
// side disagreed about the UNASSIGNED row. `isLocked` (optimizerScreen.js)
// special-cases an empty payroll to `""`, but `tsToggleCellLock` fed the same
// empty value straight into `dataFormatting_payrollFields`, whose
// `padStart(7, "0")` turns "" into **"0000000"**. So an unassigned-row lock
// READ as locked while the unlock lookup searched for a payroll that no
// document has — `find` missed, and the handler returned silently, forever.
// Live evidence at the time: 20 locked Attributes docs stored with
// `_kf_payrollNo: ""` that could never be cleared through the UI, plus 4 docs
// carrying the "0000000" sentinel the create path had written.
//
// Both sides now derive the key here, so they cannot drift again.

/**
 * @param {string|number} payrollNo - raw cell payroll ("" for the unassigned row)
 * @param {Function} formatPayroll - the app's `dataFormatting_payrollFields`
 * @returns {string} "" for the unassigned row, else the formatted payroll
 */
export function attributeCellPayrollKey(payrollNo, formatPayroll) {
  // Empty / absent payroll = the UNASSIGNED row. It must stay "" — padding it
  // invents a "0000000" installer that matches no document.
  if (payrollNo === "" || payrollNo === null || payrollNo === undefined) {
    return "";
  }
  return typeof formatPayroll === "function"
    ? formatPayroll(payrollNo)
    : String(payrollNo);
}
